import { NavLink } from "react-router-dom";

const NAV_ITEMS = [
  { to: "/", label: "ホーム", icon: "🏠" },
  { to: "/calendar", label: "カレンダー", icon: "📅" },
  { to: "/reservations/new", label: "申請", icon: "📝" },
  { to: "/my-reservations", label: "自分の利用", icon: "💻" },
  { to: "/settings", label: "設定", icon: "⚙️" },
];

export function MobileBottomNav() {
  return (
    <nav className="mobile-bottom-nav">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === "/"}
          style={({ isActive }) => ({
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            textDecoration: "none",
            color: isActive ? "var(--color-primary)" : "var(--color-text-muted)",
            fontSize: 11,
            fontWeight: 600,
          })}
        >
          <span style={{ fontSize: 18 }}>{item.icon}</span>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
